import { http } from 'api';

const AREA = 'facility';

export const getFacilityAllClassesApi = (id) => http.get(`${AREA}/${id}/names-of-classes`);
export const getAllFacilitiesApi = (params) =>
  http.get(AREA, {
    params,
  });
export const getFacilityByIdApi = (id) => http.get(`${AREA}/${id}`);
